import { z } from '@/utils/zod'
import { createCurrencySchema } from '@/entities/common'

import { AccountFilterSchema } from './Account'

const AccountingStatementCategorySchema = z.string().min(1).max(280)

//
// Input
//

const BaseAccountingStatementTemplateLineSchema = z.object({
    category: AccountingStatementCategorySchema,
    accounts: AccountFilterSchema.shape.accounts.optional(),
    expressions: z.array(z.string().min(1)).optional(),
})

export type AccountingStatementTemplateLine = z.infer<typeof BaseAccountingStatementTemplateLineSchema> & {
    lines?: AccountingStatementTemplateLine[]
}

export const AccountingStatementTemplateLineSchema: z.ZodType<AccountingStatementTemplateLine> =
    BaseAccountingStatementTemplateLineSchema.extend({
        lines: z.lazy(() => AccountingStatementTemplateLineSchema.array().optional()),
    }) /* .openapi({ ref: 'AccountingStatementTemplateLineSchema', title: 'lines' }) */

export const AccountingStatementTemplateSchema = z.object({
    name: z.string().min(1).max(40),
    title: z.string().min(1).max(140),
    lines: z.array(AccountingStatementTemplateLineSchema),
})

export type AccountingStatementTemplate = z.infer<typeof AccountingStatementTemplateSchema>

//
// Output
//

const BaseAccountingStatementLineSchema = z.object({
    category: AccountingStatementCategorySchema,
    balances: z.array(createCurrencySchema({ canBeNegative: true, canBeZero: true })),
    previousBalances: z.array(createCurrencySchema({ canBeNegative: true, canBeZero: true })).optional(),
    isTotal: z.boolean().optional(),
})

export type AccountingStatementLine = z.infer<typeof BaseAccountingStatementLineSchema> & {
    lines?: AccountingStatementLine[]
}

export const AccountingStatementLineSchema: z.ZodType<AccountingStatementLine> =
    BaseAccountingStatementLineSchema.extend({
        lines: z.lazy(() => AccountingStatementLineSchema.array().optional()),
    })

export const AccountingStatementSchema = z.object({
    name: z.string().min(1).max(40),
    title: z.string().min(1).max(140),
    lines: z.array(AccountingStatementLineSchema),
})

export type AccountingStatement = z.infer<typeof AccountingStatementSchema>
